import React, { useEffect, useState } from "react";
import { Checkbox, Spin } from "antd";
import { authenticatedFetch } from "core/components/AuthProvider";
import { MicroservicesEndpoint } from "common/services/ApiServerService";
import { DropdownClient, IDropbownSaleStatus } from "common/services/microservices/basic-client";

interface Props {
  selectedStatuses: number[];
  onStatusesSelected: (statuses: number[]) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export function StatusCheckboxes(props: Props): JSX.Element {
  const { selectedStatuses, onStatusesSelected, disabled } = props;
  const [loading, setLoading] = useState<boolean | undefined>(undefined);
  const [productCategoryList, setProductCategoryList] = useState<IDropbownSaleStatus[]>([]);

  useEffect(() => {
    const getProductCategory = () => {
      authenticatedFetch(MicroservicesEndpoint.basic, DropdownClient, (c) => {
        setLoading(true);
        return c.getActiveStatuses();
      })
        .then((res) => {
          setProductCategoryList(res.sort((a, b) => a.sale_status_name.localeCompare(b.sale_status_name)));
        })
        .finally(() => {
          setLoading(false);
        });
    };
    getProductCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Spin />;
  }

  return (
    <>
      {productCategoryList.map((carrier, i) => (
        <Checkbox
          key={i}
          style={{ margin: 0 }}
          disabled={disabled || loading}
          value={selectedStatuses.includes(carrier.ens_sale_status_tid)}
          onChange={(f) => {
            const checked = f.target.checked;
            if (checked) {
              onStatusesSelected([...selectedStatuses, carrier.ens_sale_status_tid]);
            } else {
              onStatusesSelected(selectedStatuses.filter((c) => c != carrier.ens_sale_status_tid));
            }
          }}
        >
          {carrier.sale_status_name}
        </Checkbox>
      ))}
    </>
  );
}
